<template>
  <div class="main-wrapper">
    <div class="login-page mt-5 py-5">
      <div class="container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Auth'
}
</script>
